import { OpenReviewPostEntryPresenter } from '@/presentation/presenters/reviewPost/openReviewPostEntryPresenter'
import { OpenReviewPostEntryViewModel } from '@/presentation/viewmodels/reviewPost/openReviewPostEntryViewModel'

export function useOpenReviewPostEntryPresenter(
  presenter: OpenReviewPostEntryPresenter = new OpenReviewPostEntryPresenter(new OpenReviewPostEntryViewModel())
) {
  return {
    entryList: presenter.entryList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    hasEntryInList: presenter.hasEntryInList,
    fetchEntryList: presenter.fetchReviewEntryList.bind(presenter)
  }
}
